import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import cx from 'classnames'

import { ActionTypes } from '@constants'
import ToolBar from './components/ToolBar'
import FileList from './components/Private'
import { FinderProvider, ACTION_TYPES } from './contexts/FinderContext'
import Frame from '../Frame'
import Preview from '../../../Preview'
import { ClassroomManager } from '../../../../helpers'
import OversizeModal from '../Modals/OversizeModal'
import { useFinder } from './hooks'
import { useFileLoader } from '@components/Classroom/hooks'

const Finder = ({ style = {}, theme = 'dark', close }) => {
  const [{ file, oversize, mode }, dispatch] = useFinder()
  const { mutateAsync: loadFile } = useFileLoader()

  const [, setExportToSketch] = useState(null)

  const { data } = useSelector((state) => ({
    data: state.files.data
  }))

  useEffect(() => {
    if (mode === 'viewer') return

    const onActiveChange = () => {
      const active = ClassroomManager.getActive('finder')
      if (!active)
        return dispatch({ type: ACTION_TYPES.UPDATE_FILE, payload: null })
      const file = data.find(({ data: { id } }) => active === id)
      if (file) dispatch({ type: ACTION_TYPES.UPDATE_FILE, payload: file.data })
      else loadFile({ id: active })
    }

    ClassroomManager.observe('frames.finder.active', onActiveChange)
    const active = ClassroomManager.getActive('finder')
    const file = data.find(({ data: { id } }) => active === id)

    if (active && file)
      dispatch({ type: ACTION_TYPES.UPDATE_FILE, payload: file.data })

    return () => {
      ClassroomManager.unobserve('frames.finder.active', onActiveChange)
    }
  }, [mode, data, dispatch, loadFile])

  useEffect(() => {
    if (mode !== 'viewer' || !file) return
    const next = data.find(({ data: { id } }) => file.id === id)
    dispatch({ type: ACTION_TYPES.UPDATE_FILE, payload: next.data })
  }, [mode, data, file, dispatch])

  return (
    <Frame
      className={cx('gp-finder', { 'is-preview': !!file })}
      style={style}
      theme={theme}
      component={{ title: 'Files', type: 'finder' }}
      {...(file
        ? {}
        : {
            toolbar: <ToolBar close={close} />
          })}
    >
      {!file ? (
        <FileList />
      ) : (
        <Preview
          exportConfig={
            mode === 'viewer'
              ? { download: true }
              : { download: true, sketch: true }
          }
          file={file}
          status={ActionTypes.STATUS.SUCCESS}
          back={() => {
            if (mode === 'viewer')
              return dispatch({ type: ACTION_TYPES.UPDATE_FILE, payload: null })
            ClassroomManager.closeFile({ id: file.id, type: 'finder' })
          }}
          exportToSketch={() => {
            setExportToSketch(file)
          }}
        />
      )}

      {oversize && (
        <OversizeModal
          files={oversize}
          close={() => dispatch({ type: ACTION_TYPES.UPDATE_OVERSIZE })}
        />
      )}
    </Frame>
  )
}

const FinderWrapper = ({ mode = 'editor', ...props }) => {
  return (
    <FinderProvider mode={mode}>
      <Finder {...props} />
    </FinderProvider>
  )
}

export default FinderWrapper
